import script from "./OSDistributionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./OSDistributionChart.vue?vue&type=script&setup=true&lang=js"

import "./OSDistributionChart.vue?vue&type=style&index=0&id=7463cbe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7463cbe4"]])

export default __exports__